import React from 'react';
import { getYear } from 'Helpers/external';
import { useSelector } from 'react-redux';
import { getInternal } from 'Features/interview/interviewSlice';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

const InterviewNotExist = ({ deleted, catcherEmail, theme }) => {
  let internal = useSelector(getInternal);

  if (!internal && internal !== '0') {
    internal = '3';
  }

  const handleClose = () => {
    const support = 'support@jobma.com';
    const email = internal === '1' ? support : catcherEmail;
    window.location.href = `mailto:${email}`;
  };

  const getHeading = () => {
    switch (internal) {
      case '2':
        return 'Kit Does Not Exist';
      case '3':
        return 'The link is not valid';
      default:
        return 'This Interview Does Not Exist Or May Be Deleted';
    }
  };

  const getSubheading = () => {
    if (internal === '2') return 'Please check your Interview Preview Link';

    if (internal === '3' || !deleted) return 'Please check your Interview Link';

    return internal === '1'
      ? 'Please Contact With Jobma Support'
      : 'Please Contact Your Employer';
  };

  const isSecondTheme = theme === 'second';

  return (
    <main className="main h-100 interview-login-screen">
      <div className="min-vh-lg-100 w-100 d-flex align-items-center">
        <div className="container text-center pt-md-3 pb-5">
          <div className="row justify-content-center">
            <div className="col-md-10 col-lg-6">
              <img
                className='w-100' 
                src="/interview/first-theme/images/svg/interview-not-exit.svg"
                style={{ maxWidth: '600px' }}
                alt="Interview not exist"
              />

              {isSecondTheme ? (
                <>
                  <h4 className="fw-bold mb-2 mt-4 access-heading-color">
                    {getHeading()}
                  </h4>
                  <h5 className="mb-3 access-heading-color">{getSubheading()}</h5>
                </>
              ) : (
                <>
                  <h3 className="fw-bold mb-2 mt-4 access-heading-color">
                    {getHeading()}
                  </h3>
                  <h4 className="mb-3 access-heading-color">{getSubheading()}</h4>
                </>
              )}

              {deleted && (
                <div className="my-3">
                  <Button variant="secondary" onClick={handleClose}>
                    Contact
                  </Button>
                </div>
              )}

              <div className="text-muted mt-5 access-content-color">
                <p className="mb-0">JOBMA © 2010-{getYear()}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

InterviewNotExist.propTypes = {
  deleted: PropTypes.bool,
  catcherEmail: PropTypes.string,
  theme: PropTypes.string,
};

InterviewNotExist.defaultProps = {
  deleted: false,
  catcherEmail: '',
  theme: '',
};

export default InterviewNotExist;
